import React from "react";
import {Link, NavLink} from "react-router-dom";
import {Role} from "../../controller/Utils";

export class AnalyticsHeaderLink extends React.Component {

render() {
  return(
      <ul className="nav justify-content-end top-submenu">
        <li>
          <NavLink activeClassName="active" to="/dashboard/employee-information/">Employee Information</NavLink>
        </li>
        <li>
          <NavLink activeClassName="active" to="/dashboard/trucks/">Trucks</NavLink>
        </li>
        <li>
          <a >Lorem Ipsum</a>
        </li>
      </ul>
    )
  }

}



// WEBPACK FOOTER //
// ./src/pages/analytics/AnalyticsHeaderLink.jsx